window.sortDocumentColumn = function (_, __, a, b) {
    var countA = a['DocumentCount'] || 0;
    var countB = b['DocumentCount'] || 0;

    var sortValueA = countA.toString();
    var sortValueB = countB.toString();

    if (countA == 1) {
        sortValueA = a['DocumentFileName'].toLowerCase();
    }

    if (countB == 1) {
        sortValueB = b['DocumentFileName'].toLowerCase();
    }

    var result = sortValueA.localeCompare(sortValueB);
    
    if (result > 0) {
        result = 1;
    }

    if (result < 0) {
        result = -1;
    }

    return result;    
}